import "@fontsource/inter";
import "@fontsource/inter/700.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/400.css";
import styled from "styled-components";
import { theme } from "../../../theme";

const BodySmall = styled.div<{
  textalign?: string;
  color?: string;
  fontweight?: string | number;
}>`
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: ${(props) => props.color ?? theme.colors.text};
  text-align: ${(props) => props.textalign ?? "left"};
  line-height: 21px;
  font-weight: ${(props) => props.fontweight ?? "400"};
`;

export default BodySmall;
